// Redaccion de todo lo que sale del registro de DevTools (panel, reporte,
// window.__heskala, puente de Vite): ningun token, credencial o secreto
// llega a un agente ni a un archivo.

const SECRET_KEY = /token|secret|password|passwd|credential|authorization|api[-_]?key|cookie|session[-_]?id|private/i;

const SECRET_VALUE: Array<[RegExp, string]> = [
  [/hskw_[A-Za-z0-9_-]+/g, "hskw_[oculto]"], // token del worker MQTT
  [/eyJ[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}/g, "[jwt oculto]"],
  [/(bearer\s+)[A-Za-z0-9._~+/=-]{12,}/gi, "$1[oculto]"],
  [/\b(sk|pk|rk)_(live|test)_[A-Za-z0-9]{8,}/g, "[clave oculta]"],
  [/(:\/\/[^:/\s]+:)[^@/\s]+@/g, "$1[oculto]@"], // credenciales en URLs
];

export function redactText(text: string): string {
  let out = text;
  for (const [re, replacement] of SECRET_VALUE) out = out.replace(re, replacement);
  return out;
}

/** Copia redactada: claves sensibles -> "[oculto]", textos filtrados. */
export function redact<T>(value: T, depth = 0): T {
  if (depth > 8) return "[profundo]" as T;
  if (typeof value === "string") return redactText(value) as T;
  if (Array.isArray(value)) return value.map((v) => redact(v, depth + 1)) as T;
  if (value && typeof value === "object") {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
      out[k] = SECRET_KEY.test(k) ? "[oculto]" : redact(v, depth + 1);
    }
    return out as T;
  }
  return value;
}
